/* Store homepage design — small behaviours for nf-* sections */
(function () {
  function init(root) {
    // Carousel arrows scroll their track.
    root.querySelectorAll('[data-nf-arrow]').forEach(function (btn) {
      if (btn.dataset.nfBound) return;
      btn.dataset.nfBound = '1';
      btn.addEventListener('click', function () {
        var shell = btn.closest('[data-nf-shell]');
        var track = shell && shell.querySelector('[data-nf-track]');
        if (!track) return;
        var dir = btn.dataset.nfArrow === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    // Review carousel dots follow scroll position.
    root.querySelectorAll('[data-nf-dots]').forEach(function (dots) {
      var shell = dots.closest('[data-nf-shell]');
      var track = shell && shell.querySelector('[data-nf-track]');
      if (!track || track.dataset.nfDots) return;
      track.dataset.nfDots = '1';
      var update = function () {
        var items = dots.children;
        if (!items.length) return;
        var max = track.scrollWidth - track.clientWidth;
        var i = max > 0 ? Math.round((track.scrollLeft / max) * (items.length - 1)) : 0;
        Array.prototype.forEach.call(items, function (d, n) { d.classList.toggle('is-active', n === i); });
      };
      track.addEventListener('scroll', update, { passive: true });
      update();
    });

    // Shelf tabs (phone layout).
    root.querySelectorAll('[data-nf-tabs]').forEach(function (tabs) {
      if (tabs.dataset.nfBound) return;
      tabs.dataset.nfBound = '1';
      var section = tabs.closest('[data-nf-shelves]');
      tabs.querySelectorAll('[data-nf-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.nfTab;
          tabs.querySelectorAll('[data-nf-tab]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          section.querySelectorAll('[data-nf-shelf]').forEach(function (s) {
            s.classList.toggle('is-active', s.dataset.nfShelf === i);
          });
        });
      });
    });

    // Announcement close.
    root.querySelectorAll('[data-nf-close]').forEach(function (btn) {
      if (btn.dataset.nfBound) return;
      btn.dataset.nfBound = '1';
      btn.addEventListener('click', function () {
        var bar = btn.closest('[data-nf-announce]');
        if (bar) bar.style.display = 'none';
      });
    });

    // Footer columns: always open on desktop, collapsible on phones.
    var mq = window.matchMedia('(min-width: 990px)');
    var syncFooter = function () {
      root.querySelectorAll('[data-nf-collapsible]').forEach(function (d) {
        if (mq.matches) d.setAttribute('open', '');
        else if (!d.dataset.nfTouched) d.removeAttribute('open');
      });
    };
    root.querySelectorAll('[data-nf-collapsible] summary').forEach(function (s) {
      if (s.dataset.nfBound) return;
      s.dataset.nfBound = '1';
      s.addEventListener('click', function (e) {
        if (mq.matches) { e.preventDefault(); return; }
        s.parentElement.dataset.nfTouched = '1';
      });
    });
    syncFooter();
    if (!window.__nfMq) { window.__nfMq = true; mq.addEventListener('change', function () { syncFooter(); }); }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Re-bind when a section is edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
